module.exports = __webpack_public_path__ + "img/purple-haze.e963ffc0.jpg";